module.exports = __webpack_public_path__ + "static/media/applenav-music.49f7b848.PNG";